import { motion } from "framer-motion";
import { fadeUp, fadeUpChild, stagger, viewportOnce } from "./anim";
import { manifesto } from "@/data/resume";

export const Manifesto = () => {
  return (
    <section
      data-testid="manifesto"
      className="relative border-y border-black/10 bg-[#F1EFE8]"
    >
      <div className="mx-auto max-w-[1500px] px-6 py-24 md:px-12 md:py-36">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mb-16 max-w-2xl"
        >
          <span className="font-mono-x text-xs uppercase tracking-[0.3em] text-[#9A7526]">
            (03) — How I work
          </span>
          <h2 className="mt-6 font-display text-4xl font-light tracking-tight text-[#1A1A18] md:text-6xl">
            Four principles behind every renewal.
          </h2>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="grid grid-cols-1 md:grid-cols-2"
        >
          {manifesto.map((c) => (
            <motion.div
              key={c.no}
              variants={fadeUpChild}
              data-testid={`manifesto-${c.no}`}
              className="group border-black/10 py-10 md:border-t md:px-10 md:odd:border-r md:[&:nth-child(-n+2)]:border-t-0"
            >
              <div className="flex items-baseline gap-6">
                <span className="font-display text-5xl font-light text-[#9A7526]/60 transition-colors duration-500 group-hover:text-[#9A7526] md:text-6xl">
                  {c.no}
                </span>
                <div>
                  <h3 className="font-display text-2xl font-light leading-snug text-[#1A1A18] md:text-3xl">
                    {c.title}
                  </h3>
                  <p className="mt-4 max-w-md font-body text-base font-light leading-relaxed text-[#6E6D66]">
                    {c.body}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
